module.exports = __webpack_public_path__ + "static/img/4_3_1.118144c5.jpg";